import { useState } from "react"
import {
  HistoricFilterModal,
  HistoricHeader,
  HistoricTabs,
} from "../../components/Historic"

export const Historic = () => {
  const [activeTab, setActiveTab] = useState("boutique")
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedActionType, setSelectedActionType] = useState<string>("all")
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)

  const handleResetFilters = () => {
    setSearchTerm("")
    setSelectedActionType("all")
  }

  return (
    <div className="h-full flex flex-col space-y-6">
      <HistoricHeader />

      <HistoricTabs
        activeTab={activeTab}
        onTabChange={setActiveTab}
        searchTerm={searchTerm}
        selectedActionType={selectedActionType}
        onOpenFilters={() => setIsFilterModalOpen(true)}
        onResetFilters={handleResetFilters}
      />

      <HistoricFilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        searchTerm={searchTerm}
        onSearchTermChange={setSearchTerm}
        selectedActionType={selectedActionType}
        onActionTypeChange={setSelectedActionType}
        onResetFilters={handleResetFilters}
      />
    </div>
  )
}
